import api from "./api";

export const getAllUsers = async () => {
  try {
    const response = await api.get('/master/users/all');
    return response.data;
  } catch (error) {
    console.error("There was an error fetching the data:", error);
    throw error;
  }
}

export const getUserById = async () => {
  try {
    const response = await api.get('/master/users/show');
    return response.data;
  } catch (error) {
    console.error("There was an error fetching the data:", error);
    throw error;
  }
}

export const createUser = async (data) => {
  try {
    const response = await api.post('/master/users/create', data);
    return response.data;
  } catch (error) {
    console.error("There was an error fetching the data:", error);
    throw error;
  }
}

export const updateUser = async (data, id) => {
  try {
    const response = await api.put(`/master/users/update/${id}`, data);
    return response.data;
  } catch (error) {
    console.error("There was an error fetching the data:", error);
    throw error;
  }
}

export const updatePassword = async (data, id) => {
  try {
    const response = await api.put(`/master/users/update-password/${id}`, data);
    return response.data;
  } catch (error) {
    console.error("There was an error fetching the data:", error);
    throw error;
  }
}

export const deleteUser = async (id) => {
  try {
    const response = await api.delete(`/master/users/delete/${id}`);
    return response.data;
  } catch (error) {
    console.error("There was an error fetching the data:", error);
    throw error;
  }
}

export const loginUser = async (data) => {
  try {
    const response = await api.post('/master/users/login', data);
    return response.data;
  } catch (error) {
    console.error("There was an error fetching the data:", error);
    throw error;
  }
}

export const logoutUser = async () => {
  try {
    const response = await api.post('/master/users/logout');
    return response.data;
  } catch (error) {
    console.error("There was an error during logout:", error);
    throw error;
  }
}
